
    /**
     * Enhanced alt-based logic for toggling product images by variant.
     * Debug logs included to help diagnose any mismatch or missing events.
     */

//      Code to dynamically switch between variant images

    (function() {
      // Helper: show only the first item and hide all others
      function showFirstItem(galleryItems) {
        galleryItems.forEach((it, idx) => {
          if (idx === 0) {
            it.removeAttribute('hidden');
          } else {
            it.setAttribute('hidden', true);
          }
        });
      }
    
      // 1) Listen for the variant:change event
      document.addEventListener('variant:change', function(event) {
        const { variant } = event.detail || {};
    
        // If no variant, fallback & bail
        if (!variant) {
          const galleryItems = document.querySelectorAll('.product-gallery__media');
          showFirstItem(galleryItems);
          return;
        }
    
        // If color is in option2 or option3, swap here
        // e.g. let variantOption = variant.option2.toLowerCase().trim();
        let variantOption = variant.option1.toLowerCase().trim();
    
        const galleryItems = document.querySelectorAll('.product-gallery__media');
        let foundOne = false;
    
        galleryItems.forEach((item) => {
          const media = item.querySelector('img, video, model-viewer');
          if (!media) return;
          
          const altText = (media.alt || '').toLowerCase().trim();
          
          // Compare alt exactly or do partial match
          if (altText === variantOption) {
            item.removeAttribute('hidden');
            foundOne = true;
          } else {
            item.setAttribute('hidden', true);
          }
        });
    
        // If no exact alt match, fallback
        if (!foundOne) {
          showFirstItem(galleryItems);
        }
      });
    
    
      // 2) On DOM load, handle whichever variant is selected by default
      document.addEventListener('DOMContentLoaded', () => {
        
        // If your color is 'option2', update the query
        const checkedRadio = document.querySelector('input[name="option1"]:checked');
        if (!checkedRadio) {
          const galleryItems = document.querySelectorAll('.product-gallery__media');
          showFirstItem(galleryItems);
          return;
        }
    
        let variantOption = checkedRadio.value.toLowerCase().trim();
    
        const galleryItems = document.querySelectorAll('.product-gallery__media');
        let foundOne = false;
    
        galleryItems.forEach((item) => {
          const media = item.querySelector('img, video, model-viewer');
          if (!media) return;
          
          const altText = (media.alt || '').toLowerCase().trim();
          if (altText === variantOption) {
            item.removeAttribute('hidden');
            foundOne = true;
          } else {
            item.setAttribute('hidden', true);
          }
        });
    
        if (!foundOne) {
          showFirstItem(galleryItems);
        }
      });
    })();
